import React from 'react'
import { Trans } from 'react-i18next'
import { useBoolean } from 'react-use'
import clsx from 'clsx'

import { Image16 } from '@makyoapp/makyo-icon/icon'

import { ImageManagerKind } from '../../context/ImageManagerContext'
import { ImageManager } from '../ImageManager/ImageManager'
import { VariableWrapper } from './VariableWrapper'

export default function VariableImage({
  id,
  onChange,
  onHide,
}: {
  id?: string
  onChange: (value: string) => void
  onHide: () => void
}) {
  const [show, setShow] = useBoolean(false)

  return (
    <VariableWrapper
      title={<Trans>Image</Trans>}
      icon={<Image16 />}
      show={show}
      defaultHeight={false}
      defaultWidth={false}
      setShow={setShow}
      placement='auto'
      defaultMenuPad={false}
      menuClassName={clsx('max-w-[800px] min-h-[500px]')}
    >
      <ImageManager
        id={id}
        modal={false}
        smallPreview
        maxHeight='65vh'
        innerClassname='w-[700px]'
        forceUrlPanelHeight
        onChange={(ty, v) => {
          switch (ty) {
            case ImageManagerKind.StockPhotos:
              onChange(`${v}?q=50&w=720`)
              break
            case ImageManagerKind.Upload:
            case ImageManagerKind.ImageUrl:
            case ImageManagerKind.OpenAI:
            default:
              onChange(`${v}`)
              break
          }
        }}
        onHide={() => {
          setShow(false)
          onHide()
        }}
      />
    </VariableWrapper>
  )
}
